'use strict';

var models = require('../../projection/geometry/models.cjs');
var DOMVisualElement = require('../dom/DOMVisualElement.cjs');
var camelToDash = require('../dom/utils/camel-to-dash.cjs');
var buildAttrs = require('./utils/build-attrs.cjs');
var camelCaseAttrs = require('./utils/camel-case-attrs.cjs');
var isSvgTag = require('./utils/is-svg-tag.cjs');
var render = require('./utils/render.cjs');
var scrapeMotionValues = require('./utils/scrape-motion-values.cjs');
var keysTransform = require('../../../../../../../motion-dom/dist/es/render/utils/keys-transform.cjs');
var defaults = require('../../../../../../../motion-dom/dist/es/value/types/maps/defaults.cjs');

class SVGVisualElement extends DOMVisualElement.DOMVisualElement {
    constructor() {
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
        this.measureInstanceViewportBox = models.createBox;
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if (keysTransform.transformProps.has(key)) {
            const defaultType = defaults.getDefaultValueType(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !camelCaseAttrs.camelCaseAttributes.has(key) ? camelToDash.camelToDash(key) : key;
        return instance.getAttribute(key);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return scrapeMotionValues.scrapeMotionValuesFromProps(props, prevProps, visualElement);
    }
    build(renderState, latestValues, props) {
        buildAttrs.buildSVGAttrs(renderState, latestValues, this.isSVGTag, props.transformTemplate, props.style);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        render.renderSVG(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = isSvgTag.isSVGTag(instance.tagName);
        super.mount(instance);
    }
}

exports.SVGVisualElement = SVGVisualElement;
//# sourceMappingURL=SVGVisualElement.cjs.map
